import { getTruckSizeVals } from '@utils';

export const getTruckSize = (id: number) => {
	const truckSize = getTruckSizeVals.find((s) => s.id === id);
	return truckSize ? truckSize.value : null;
}
